export default __webpack_public_path__ + "static/media/mojaco_greeting_large.e7c125ca.png";